import React,{ useEffect, useState, useCallback, useRef } from 'react';
import Storage from "@aws-amplify/storage";
import CardMedia from '@mui/material/CardMedia';
import ProjectsImageBanner from '../../../assets/projects.jpg';
import { getSignedUrl } from '../../auth/util/util';

function ShowImage(props) {
    const [url,setUrl]=useState('');

    useEffect(()=>{
        const initiateFun = async() => {
        if(props.url)
        {
            let imageURL='';
            let result = await Storage.list('projects/thumb/'+props.url)
            console.log('string',result)
            if(result.length>0)
            {
                imageURL='projects/thumb/'+props.url
            }
            else
            {
                imageURL=props.url
            }
            console.log('props.url',props.url);
            let newurl=await getSignedUrl(imageURL, { level: 'public'});
            console.log('props.url',newurl);
            setUrl(newurl)
        }
        else
        {
            setUrl(ProjectsImageBanner)
        }
    }
    initiateFun();
    },[url])
    
    return (
        <>
        {url!='' &&
            <CardMedia component="img" image={url} {...props} />
        }
        </>
    );
}

export default ShowImage;